import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';
import { RestaurantTableService } from '@core';

@Component({
  selector: 'app-service-center-amenities',
  templateUrl: './service-center-amenities.component.html',
  styleUrls: ['./service-center-amenities.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceCenterAmenitiesComponent {
  private readonly restaurantTable = inject(RestaurantTableService);


  public readonly wifiCredentials = toSignal(this.restaurantTable.table$.pipe(
    map((table) => {
      if (!table) {
        return undefined;
      }

      return {
        name: table.wifiName,
        password: table.wifiPassword,
      };
    }),
  ));

}
